import { ExpectedRowTypes, TableProps } from "@/common/types";
import { useEffect, useState } from "react";
import Paginator from "../table/paginator";

const CardsForTable = ({
  columns,
  rows,
  totalPages = 0,
  selectedPage = 1,
  showPrevious = false,
  showNext = false,
  onRowClick,
  onPageChange,
}: TableProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const currentData: ExpectedRowTypes[] = rows;

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    onPageChange?.(page);
  };

  useEffect(() => {
    setCurrentPage(selectedPage);
  }, [selectedPage]);

  return (
    <div className="w-full">
      <div className="flex flex-col gap-2">
        {currentData.length > 0 &&
          currentData.map((row, rowIndex) => (
            <div
              className="border px-4 py-2 rounded-md"
              key={rowIndex}
              onClick={(e) => onRowClick?.(e, row)}
            >
              {columns.map((column) => (
                <div className="grid grid-cols-3" key={column.field}>
                  <p className="font-bold col-span-1">{column.headerName}: </p>
                  <p key={column.field} className="col-span-2 break-words">
                    {column.render
                      ? column.render(row)
                      : column.field in row
                      ? (row as any)[column.field]
                      : ""}
                  </p>
                </div>
              ))}
            </div>
          ))}
      </div>
      <Paginator
        currentPage={currentPage}
        totalPages={totalPages}
        showPrevious={showPrevious}
        showNext={showNext}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default CardsForTable;
